import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faUnlock } from "@fortawesome/free-solid-svg-icons";

const LOCKED_TITLE =
  "These fields were auto-filled from the bank lookup and are locked to prevent accidental changes. " +
  "Click to unlock and edit them manually.";
const UNLOCKED_TITLE =
  "Fields are unlocked and can be edited. Click to lock them again.";

const LockFieldsButton = ({ allowEdit, setAllowEdit }) => {
  return (
    <div className="mb-3 d-flex align-items-center">
      <button
        type="button"
        className="btn btn-link p-0 text-decoration-none"
        onClick={() => setAllowEdit(!allowEdit)}
        title={allowEdit ? UNLOCKED_TITLE : LOCKED_TITLE}
        style={{ fontSize: '1.2rem', cursor: 'pointer' }}
      >
        <FontAwesomeIcon
          icon={allowEdit ? faUnlock : faLock}
          className={allowEdit ? "text-warning" : "text-secondary"}
        />
      </button>
      <small className="text-muted ms-2" title={allowEdit ? UNLOCKED_TITLE : LOCKED_TITLE} style={{ cursor: 'help' }}>
        {allowEdit ? "Unlocked – click the icon to lock" : "Locked – click the icon to edit manually"}
      </small>
    </div>
  );
};

export default LockFieldsButton;
